import { Component } from '@angular/core';

import '../assets/app.css';

@Component({
    moduleId: module.id.toString(),
    selector: 'app',
    templateUrl: 'app.component.html'
})

export class AppComponent { }


// WEBPACK FOOTER //
// ./src/app/app.component.ts